import { forwardRef, FC } from 'react'
import { Button, StyleProps, useBreakpointValue } from '@chakra-ui/react'

const PrimaryButton: FC<any & StyleProps> = forwardRef(({ width, action, onClick, ...props }, ref) => {
  const buttonSize = useBreakpointValue(['md', 'lg'])

  return <Button
    bg="primaryGreen.300"
    color="primaryGreen.900"
    fontFamily="Montserrat-SemiBold"
    fontWeight="inherit"
    borderRadius={4}
    overflow="hidden"
    width={width || '100%'}
    size={buttonSize}
    _active={{
      bg: 'primaryGreen.800',
      color: 'baseWhite',
    }}
    _hover={{
      bg: props.disabled ? '' : 'primaryGreen.900',
      color: props.disabled ? '' : 'baseWhite',
    }}
    _disabled={{
      bg: 'baseNeutral.200',
      color: 'baseNeutral.400',
      cursor: 'default'
    }}
    onClick={onClick}
    {...props}
  >
    {action}
  </Button>
})

export default PrimaryButton
